import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { firebaseDB } from '../../firebase-config';
import { useAuth } from '../../contexts';
import { Loading } from '../components';
import { AddChild, ListChildren } from './componets';
import './user.scss';

export const UserDashboard = () => {
    const [userChildren, setUserChildren] = useState([]);
    const { user } = useAuth();
    const usersChildrenCollectionRef = user &&
        collection(firebaseDB, `usersChildren/${user.uid}/children`);
    const getUserChildren = async () => {
        const data = await getDocs(usersChildrenCollectionRef);
        setUserChildren(data.docs.map(doc => ({ ...doc.data(), id: doc.id })));
    };

    useEffect(() => {
        getUserChildren();
        // eslint-disable-next-line
    }, [user]);

    return (
        <>
            {!user ?
                <Loading /> :
                <div className='user-wrapper'>
                    <AddChild getUserChildren={getUserChildren} />
                    <h3>Список дітей</h3>
                    <ListChildren userChildren={userChildren} getUserChildren={getUserChildren} />
                </div>
            }
        </>
    )
}